import { t } from "@lingui/macro";
import { db, updateCall } from "@repo/ui";
import * as Sentry from "@sentry/react";
import { toast } from "sonner";

export function useCallListActions(companyId?: string) {
	const markRead = async (callId: string, read: boolean) => {
		if (!companyId) return;
		try {
			await updateCall(db, companyId, callId, {
				interactionStatus: read ? "read" : "unread",
			});
			toast.success(
				read
					? t({ id: "callMarkedRead", message: "Call marked as read" })
					: t({ id: "callMarkedUnread", message: "Call marked as unread" }),
			);
		} catch (error) {
			Sentry.captureException(error);
			toast.error(
				read
					? t({
							id: "callMarkReadFailed",
							message:
								"The call could not be marked as read. Please try again.",
						})
					: t({
							id: "callMarkUnreadFailed",
							message:
								"The call could not be marked as unread. Please try again.",
						}),
			);
		}
	};
	const toggleArchive = async (callId: string, status?: string) => {
		if (!companyId) return false;
		const archived = status !== "archived";
		try {
			await updateCall(db, companyId, callId, {
				interactionStatus: archived ? "archived" : "read",
			});
			toast.success(
				archived
					? t({ id: "callArchived", message: "Call archived" })
					: t({ id: "callUnarchived", message: "Call unarchived" }),
			);
			return archived;
		} catch (error) {
			Sentry.captureException(error);
			toast.error(
				t({
					id: "callArchiveUpdateFailed",
					message: "The archive status could not be updated. Please try again.",
				}),
			);
			return false;
		}
	};
	return { markRead, toggleArchive };
}
